import axiosClient from '../../../config/axios-client'

const FeedbackService = {
  getQuestions() {
    return axiosClient.get(`/platform/questions`)
  },

  sendAnswer(payload) {
    return axiosClient.post(`/platform/review`, payload)
  },
}

export default FeedbackService
